import { render, staticRenderFns } from "./RequestKitsThankYou.vue?vue&type=template&id=7b743204&scoped=true"
import script from "./RequestKitsThankYou.vue?vue&type=script&lang=js"
export * from "./RequestKitsThankYou.vue?vue&type=script&lang=js"
import style0 from "./RequestKitsThankYou.vue?vue&type=style&index=0&id=7b743204&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b743204",
  null
  
)

export default component.exports